/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetNotificationTypesQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type GetNotificationTypesQuery = { __typename?: 'Query', notificationTypes: any };

export type GetNotificationsQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationListResponse', data: Array<{ __typename?: 'Notification', id: number, createdAt?: any | null, updatedAt?: any | null, title: string, body: string, seen: boolean, read: boolean, data: any, user: { __typename?: 'User', id: number } }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type NotificationDataFragment = { __typename?: 'Notification', id: number, createdAt?: any | null, updatedAt?: any | null, title: string, body: string, seen: boolean, read: boolean, data: any, user: { __typename?: 'User', id: number } };

export type GetUnseenNotificationsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnseenNotificationsCountQuery = { __typename?: 'Query', unseenCount: number };

export type OnNotificationSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnNotificationSubscription = { __typename?: 'Subscription', notification: { __typename?: 'Notification', id: number, title: string } };

export type MarkAllSeenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MarkAllSeenMutation = { __typename?: 'Mutation', markAllSeen: Array<{ __typename?: 'Notification', id: number, seen: boolean }> };

export type MarkAllReadMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MarkAllReadMutation = { __typename?: 'Mutation', markAllRead: Array<{ __typename?: 'Notification', id: number, read: boolean }> };

export type MarkSeenMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type MarkSeenMutation = { __typename?: 'Mutation', markSeen: Array<{ __typename?: 'Notification', id: number, seen: boolean }> };

export type MarkReadMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type MarkReadMutation = { __typename?: 'Mutation', markRead: Array<{ __typename?: 'Notification', id: number, read: boolean }> };

export const NotificationDataFragmentDoc = gql`
    fragment NotificationData on Notification {
  id
  createdAt
  updatedAt
  title
  body
  seen
  read
  data
  user {
    id
  }
}
    `;
export const GetNotificationTypesDocument = gql`
    query GetNotificationTypes($id: Int!) {
  notificationTypes(id: $id)
}
    `;

export function useGetNotificationTypesQuery(options: Omit<Urql.UseQueryArgs<GetNotificationTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationTypesQuery>({ query: GetNotificationTypesDocument, ...options });
};
export const GetNotificationsDocument = gql`
    query GetNotifications($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  notifications(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      ...NotificationData
    }
    pageData {
      count
      limit
    }
  }
}
    ${NotificationDataFragmentDoc}`;

export function useGetNotificationsQuery(options?: Omit<Urql.UseQueryArgs<GetNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationsQuery>({ query: GetNotificationsDocument, ...options });
};
export const GetUnseenNotificationsCountDocument = gql`
    query GetUnseenNotificationsCount {
  unseenCount
}
    `;

export function useGetUnseenNotificationsCountQuery(options?: Omit<Urql.UseQueryArgs<GetUnseenNotificationsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUnseenNotificationsCountQuery>({ query: GetUnseenNotificationsCountDocument, ...options });
};
export const OnNotificationDocument = gql`
    subscription OnNotification {
  notification {
    id
    title
  }
}
    `;

export function useOnNotificationSubscription<TData = OnNotificationSubscription>(options: Omit<Urql.UseSubscriptionArgs<OnNotificationSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OnNotificationSubscription, TData>) {
  return Urql.useSubscription<OnNotificationSubscription, TData, OnNotificationSubscriptionVariables>({ query: OnNotificationDocument, ...options }, handler);
};
export const MarkAllSeenDocument = gql`
    mutation MarkAllSeen {
  markAllSeen {
    id
    seen
  }
}
    `;

export function useMarkAllSeenMutation() {
  return Urql.useMutation<MarkAllSeenMutation, MarkAllSeenMutationVariables>(MarkAllSeenDocument);
};
export const MarkAllReadDocument = gql`
    mutation MarkAllRead {
  markAllRead {
    id
    read
  }
}
    `;

export function useMarkAllReadMutation() {
  return Urql.useMutation<MarkAllReadMutation, MarkAllReadMutationVariables>(MarkAllReadDocument);
};
export const MarkSeenDocument = gql`
    mutation MarkSeen($ids: [Int!]!) {
  markSeen(ids: $ids) {
    id
    seen
  }
}
    `;

export function useMarkSeenMutation() {
  return Urql.useMutation<MarkSeenMutation, MarkSeenMutationVariables>(MarkSeenDocument);
};
export const MarkReadDocument = gql`
    mutation MarkRead($ids: [Int!]!) {
  markRead(ids: $ids) {
    id
    read
  }
}
    `;

export function useMarkReadMutation() {
  return Urql.useMutation<MarkReadMutation, MarkReadMutationVariables>(MarkReadDocument);
};